import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import PropTypes from 'prop-types'
import { Link, useHistory } from 'react-router-dom'

import { uiGet } from 'irmlib/http'
import { FlexByRow, FloatRight, YDivider, HalfScreen, useTheme, XDivider, makeStyles } from 'irmlib/styles'
import { MoreVert } from 'irmlib/icons'
import { Label, MenuButton, OutlinedButton, ContainedButton } from 'irmlib/components/Controls'
import { setBusy, clearBusy, closeGeneralDialog, LocalToast, openGeneralDialog } from 'irmlib/containers'
import * as constants from 'irmlib/common/constants'

import Table from '../../../Controls/Table'
import { getUser, getUserRole } from '../../../../redux/global'
import * as gdeTrancactions from '../../../../services/firestore/gdeTransactions'
import * as routePaths from '../../../../navigation/routePaths'
import { defaultDateFormat } from '../../../../common/constants'
import { useTranslation } from 'react-i18next'

const minWidth = '100px'

const BottomPaddedDiv = styled('div')`
  padding-bottom: 20px;
`

const TableContainer = styled(BottomPaddedDiv)`
  max-height: 700px;
`
const EditLink = styled(Link)`
  color: ${props => props.theme.palette.primary.main};
  text-decoration: none;
  text-overflow: clip;
`

const useStyles = makeStyles({
  disabledState: {
    pointerEvents: 'none',
    opacity: '0.4'
  },
  startButton: {
    textDecoration: 'none'
  }
})


const TemplateSearchTabledata = (props) => {
  const { t } = useTranslation()
  const tableRef = useRef(null)
  const theme = useTheme()
  const history = useHistory()
  const value = props.FilterData
  const refLocalToast = useRef(null)
  const classes = useStyles()
  const [Refresh, setRefresh] = React.useState(false)

  useEffect(() => {
  }, [Refresh])


  useEffect(() => {
  }, [location])

  useEffect(() => {
    const dataFilter = getPageData()
    props.dataFilter(dataFilter)
  }, [])

  useEffect(() => {
    tableRef.current.dataManager.changeSearchText(props.DataSearch)
    tableRef.current.setState(tableRef.current.dataManager.getRenderState())
  }, [props])

  const dataRet = async (val) => {
    setBusy()
    return await gdeTrancactions.getQueryTemplates2(val)
      .then((coll) => {
        const val3 = []
        coll.forEach((doc) => {
          let docData
          let isValid
          if (val.dateCreatedFrom !== constants.defaultSelect || val.dateCreatedTo !== constants.defaultSelect) {
            docData = doc.data()
            isValid = true
            if (val.dateCreatedFrom !== constants.defaultSelect && val.dateCreatedTo !== constants.defaultSelect) {
              const dateCreatedFrom = moment(val.dateCreatedFrom).format(defaultDateFormat)
              const dateCreatedTo = moment(val.dateCreatedTo).format(defaultDateFormat)
              const dateVal = moment(docData.createdTs?.seconds, 'X').format(defaultDateFormat)
              if ((dateCreatedFrom < dateVal || dateCreatedFrom === dateVal) && (dateCreatedTo > dateVal || dateCreatedTo === dateVal)) {
                isValid = false
              }
            } else if (val.dateCreatedFrom !== constants.defaultSelect) {
              const dateCreatedFrom = moment(val.dateCreatedFrom).format(defaultDateFormat)
              const dateVal = moment(docData.createdTs?.seconds, 'X').format(defaultDateFormat)
              if (dateCreatedFrom < dateVal || dateCreatedFrom === dateVal) {
                isValid = false
              }
            } else if (val.dateCreatedTo !== constants.defaultSelect) {
              const dateCreatedTo = moment(val.dateCreatedTo).format(defaultDateFormat)
              const dateVal = moment(docData.createdTs?.seconds, 'X').format(defaultDateFormat)
              if (dateCreatedTo > dateVal || dateCreatedTo === dateVal) {
                isValid = false
              }
            }
          }
          if (!isValid) {
            pushData(doc, val3)
          }
        })
        clearBusy()
        return val3
      })
  }

  const pushData = (doc, val) => {
    val.push({
      JobId: doc.id,
      templateName: doc.data().templateName !== undefined ? doc.data().templateName : doc.data().standardTemplateName,
      templateType: doc.data().templateType,
      wms: doc.data().wmsCode,
      dateCreated: doc.data().createdTs ? moment(doc.data().createdTs.seconds, 'X').format(defaultDateFormat) : '00/00/0000',
      Boxes_Complete: doc.data().boxCountForSubmittion,
      createdBy: doc.data().createdBy,
      customerIdName: doc.data().accountLevel1,
      isActive: doc.data()?.isActive
    })
  }

  const getPageData = async (page, pageSize) => {
    return await uiGet({ service: () => dataRet(value) })
  }

  const ContentForDeleteBox = (props) => (
    <>
      <Label noTranlate={true}>{props.t('Search.DeleteBoxContentTemp')}</Label>
      <Label noTranlate={true}>{props.t('Search.DeleteBoxContent2')}</Label>
      <VerticalDivider />
    </>
  )

  ContentForDeleteBox.propTypes = {
    t: PropTypes.any
  }

  const DeleteBox = (props) => (
    <>
      <VerticalDivider />
      <XDivider width="35px" />
      <OutlinedButton id={'templateSearch_delete_cancel'} style={{ minWidth }} onClick={props.handleCancel} >Search.Cancel</OutlinedButton>
      <ContainedButton id={'templateSearch_delete_yes'} style={{ minWidth }} onClick={props.handleDelete}>Search.yes</ContainedButton>
      <XDivider width="35px" />
    </>
  )

  DeleteBox.propTypes = {
    handleCancel: PropTypes.func,
    handleDelete: PropTypes.func
  }

  const handleCalcelDeleteBox = () => {
    setRefresh(value => !value)
    closeGeneralDialog()
  }

  const handleDelete = (data) => {
    gdeTrancactions.deleteTemplate(data.JobId)
      .then(() => {
        setRefresh(value => !value)
        refLocalToast.current?.successToastOn({
          message: t('toast.Deleted'),
          noTranslateMessage: true
        })
      })
    closeGeneralDialog()
  }

  const openDeleteBoxDialog = (rowdata) => {
    openGeneralDialog({
      title: t('Search.DeleteTemplate'),
      message: <ContentForDeleteBox t={t} />,
      translateMessage: false,
      noTranslateTitle: true,
      closeX: true,
      buttons: (
        <DeleteBox
          handleCancel={handleCalcelDeleteBox}
          handleDelete={() => handleDelete(rowdata)}
        />
      )
    })
    return Promise.resolve()
  }

  const onSelect = async (v, rowdata) => {
    if (v === 'Edit') {
      history.push(`${routePaths.editTemplate}/${rowdata.templateName}`, { isTitle: false, state: { detail: value }, })
    }
    if (v === 'Delete') {
      const jobs = await gdeTrancactions.getInProcessJobsForTemplate(rowdata.templateName)
      if (jobs.docs.length === 0) {
        openDeleteBoxDialog(rowdata)
      } else {
        openGeneralDialog({
          title: t('Search.DeleteTemplate'),
          message: t('templates.cannotDelete'),
          closeX: true,
          translateMessage: false,
          noTranslateTitle: true,
        })
      }
    }
  }

  const columns = [
    {
      title: t('Search.templateName'),
      field: 'templateName',
      iseditable: 'none',
      editable: 'never',
      headerAlign: 'center',
      render: (rowdata) => (
        <EditLink id={`templateSearch_${rowdata.templateName}`} className={rowdata?.isActive === false ? classes.disabledState : null} theme={theme} to={{ pathname: `${routePaths.editTemplate}/${rowdata.templateName}`, state: { isTitle: true, state: { detail: value } } }}>
          {rowdata.templateName}
        </EditLink>
      )
    },
    {
      title: t('Search.templateType'),
      field: 'templateType',
      iseditable: 'none',
      editable: 'never',
      headerAlign: 'center',
    },
    {
      title: t('Search.wms'),
      field: 'wms',
      editable: 'never',
      headerAlign: 'center',
      sortable: false,
    },
    {
      title: t('Search.dateCreated'),
      field: 'dateCreated',
      editable: 'never',
      headerAlign: 'center',
      sortable: false,
    },
    {
      title: t('Search.customerId-Name'),
      field: 'customerIdName',
      editable: 'never',
      headerAlign: 'center',
      sortable: false,
    },
    {
      title: t('Search.createdBy'),
      field: 'createdBy',
      editable: 'never',
      headerAlign: 'center',
      sortable: false,
    },
  ]

  const menuItemsForAdmin = [
    { value: 'Delete', label: t('Search.deleteTemplate'), style: { color: theme.palette.primary.main } },
    { value: 'Edit', label: t('Search.editTemplate'), style: { color: theme.palette.primary.main } },
  ]
  const menuItemsForSupervisor = [
    { value: 'Delete', label: t('Search.deleteTemplate'), style: { color: theme.palette.primary.main } },
  ]

  const VerticalDivider = () =>
    <YDivider height='50px' />
  return (
    <>
      <TableContainer>
        <LocalToast ref={refLocalToast} />
        <FlexByRow>
          <HalfScreen>
          </HalfScreen>
          <HalfScreen>
            <FloatRight>
              {getUser().role === 'ADMIN'
                ? <OutlinedButton size='small' id={'templateSearch_createNew'} variant='contained' onClick={() => history.push(`${routePaths.createTemplate}`)} >
                  demo.createNewTemplate
                </OutlinedButton>
                : null}
            </FloatRight>
            <YDivider height='40px' />
          </HalfScreen>
        </FlexByRow>
        <Table
          title={props.FilterData}
          actions={[
            {
              action: rowData => ({
                icon: () => {
                  //  console.log('rowData=>', rowData, data)
                  return (
                    <MenuButton
                      id={'templateSearch_ellipsis'}
                      buttonIcon={<MoreVert />}
                      noTranslate={true}
                      items={getUser().role === 'ADMIN' || getUser().role === 'SUPER USER' ? menuItemsForAdmin : menuItemsForSupervisor}
                      onSelect={(value) => { onSelect(value, rowData) }}
                    />)
                },

              }),
              position: 'row',

            },
          ]}
          tableRef={tableRef}
          totalRecords={200}
          columns={columns}
          refresh={Refresh}
          getPageData={getPageData}
          exportButton={false}
          paging={true}
          draggable={false}
          search={false}
          backgroundColor={'default'}
          sorting={true}
          selection={getUserRole() === props.Jobs}
          toolbar={true}

        />
      </TableContainer>
    </>
  )
}

TemplateSearchTabledata.propTypes = {
  FilterData: PropTypes.array,
  DataSearch: PropTypes.string,
  Jobs: PropTypes.string,
  dataFilter: PropTypes.func
}

export default TemplateSearchTabledata